import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section } from './Section';
export function Guarantee() {
  return <Section background="paper" width="narrow" labelledBy="guarantee-heading" data-id="element-134" data-mp="1o2vk0ww891a9">
      <div className="text-center" data-id="element-135" data-mp="223obf8r8fg95">
        <ShieldCheckIcon className="mx-auto h-10 w-10 text-sage" strokeWidth={1.25} aria-hidden="true" data-id="element-136" data-mp="222n0d4a7utrf" />

        <h2 id="guarantee-heading" className="mt-6 font-serif text-3xl font-semibold leading-[1.15] text-ink sm:text-[40px]" data-id="element-137" data-mp="19e7ogqmdsrkb">
          The "more prepared by your next class" guarantee
        </h2>

        <p className="mt-6 font-serif text-xl font-medium italic leading-snug text-brass sm:text-2xl" data-id="element-138" data-mp="1j5c47sjvsgg7">
          Download it. Open Volume 1. Use the 90-Second Screen with one real client.
        </p>

        <p className="mt-6 font-sans text-[17px] leading-[1.65] text-ink-soft" data-id="element-139" data-mp="qmyekg8p80s7">
          If within 7 days you don't feel more prepared for your very next class, email us — 100%
          refund, no forms, no questions. And you keep every file.
        </p>
      </div>
    </Section>;
}